import hoistNonReactStatic from 'hoist-non-react-statics';
import { get, concat } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import {
    THEME_ROOT_KEY,
    ZD_DIRECTORY_ID,
    getDisplayName,
    isZocdocBrand,
} from '@zocdoc-frontend-common/utils-react';
import { recordAssignments } from './recordAssignment';

const returnTrue = () => true;

export const recordAssignmentsOnMount = (
    experiments,
    shouldRecord = returnTrue
) => {
    // Make sure experiments is an array
    experiments = concat(experiments);

    if (experiments.some((experiment) => experiment.recordManually))
        throw new Error(
            'Manual experiments should not be passed to recordAssignmentsOnMount()'
        );

    if (typeof shouldRecord !== 'function') {
        throw new Error('shouldRecord should be a function');
    }

    return (WrappedComponent) => {
        /**
         * @param {boolean} is1Z
         * @returns {JSX.Element}
         */
        class ABWrapper extends React.Component {
            static displayName = `ABWrapper(${getDisplayName(
                WrappedComponent
            )})`;

            componentDidMount() {
                // We should not record assignments on white-label sites.
                if (!this.props.is1Z || !shouldRecord()) return;

                if (document.readyState === 'complete') {
                    this.handleLoadWindow();
                } else {
                    window.addEventListener('load', this.handleLoadWindow);
                }
            }

            componentWillUnmount() {
                window.removeEventListener('load', this.handleLoadWindow);
            }

            render() {
                const { is1Z, ...props } = this.props;

                return (
                    <WrappedComponent
                        data-test="ab-wrapped-component"
                        {...props}
                    />
                );
            }

            handleLoadWindow = () => {
                recordAssignments(experiments);
            };
        }

        hoistNonReactStatic(ABWrapper, WrappedComponent);

        return connect(mapStateToProps)(ABWrapper);
    };
};

const mapStateToProps = (state) => ({
    is1Z: isZocdocBrand(
        get(state, `${THEME_ROOT_KEY}.directoryId`, ZD_DIRECTORY_ID)
    ),
});
